export const RoleConstants = {
    LEAGUE_PRESIDENT: "PARTNER-LEAGUE-PRESIDENT",
    CLUB_ADMIN: "PARTNER-LEAGUE-CLUB-ADMIN",
    CLUB_VIEWER: "PARTNER-LEAGUE-CLUB-USER",
    BOC: "PARTNER-LEAGUE-PRESIDENT-BOC",
    CLUB_PREFIX: "PARTNER-USER-",
    PRESIDENT_PREFIX: "PARTNER-LEAGUE-PRESIDENT-",
};
